import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useMainStore } from "@/stores/main";
import Tool from "@/components/tools/Tool.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ThresholdSlider',
  setup(__props) {

const store = useMainStore();

return (_ctx: any,_cache: any) => {
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createBlock(Tool, {
    label: 'Toon partijen met meer dan <' + _unref(store).threshold + '> stemmen'
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_slider, {
        modelValue: _unref(store).threshold,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).threshold) = $event)),
        min: 0,
        max: 500000,
        step: 25000,
        "show-ticks": ""
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})